export function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;

  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as { message?: unknown }).message === "string"
  ) {
    return String((error as { message: string }).message);
  }

  return "";
}

export function formatServiceError(error: unknown, fallback: string) {
  const message = getErrorMessage(error).replace(/\s+/g, " ").trim();

  if (!message) return fallback;

  if (
    /<\/?[a-z][\s\S]*>|<!doctype html/i.test(message) ||
    /\b(502|503|504)\b|bad gateway|service unavailable|gateway timeout|nginx|upstream/i.test(
      message,
    ) ||
    /failed to fetch|networkerror|load failed|could not connect|connection refused|no api key/i.test(
      message,
    )
  ) {
    return fallback;
  }

  return message;
}
